import { fileshubPreviewNotSupportedError } from '../strings.locstring.json';
import loc from 'owa-localize';
import { getSxSViewStore, SharePointFileInformation } from 'owa-group-files-hub-store';
import { IsPreviewSupported } from 'owa-group-files-hub-actions/lib/utils/fileActionManager';
import downloadRecentFileAction from './downloadRecentFileAction';
import previewSharePointFileInNewSxS from './preview-sharepoint-in-sxs/previewSharePointFileInNewSxS';
import prepareSharePointFileViewState from './preview-sharepoint-in-sxs/prepareSharePointFileViewState';
import { GroupFilesHubRecentFilesCardDefaultActionClickName } from '../logging/datapoints';
import { DatapointStatus, logUsage, PerformanceDatapoint } from 'owa-analytics';

export default function clickSharePointFile(
    fileInformation: SharePointFileInformation,
    cardIndex: number
) {
    // In case user clicked on another file yet this datapoint has not ended for a previous file,
    // we end the datapoint here to prevent timeout on the previous datapoint instance
    if (getSxSViewStore().datapoint != null) {
        getSxSViewStore().datapoint.end();
    }

    if (IsPreviewSupported(fileInformation.fileType, fileInformation.extension)) {
        logUsage(GroupFilesHubRecentFilesCardDefaultActionClickName, {
            IndexOfCard: cardIndex.toString(),
            ActionPerformed: 'Preview',
        });

        getSxSViewStore().datapoint = new PerformanceDatapoint(
            'GroupFilesHubPreviewSharePointFileInNewSxSDP',
            {
                isCore: true,
            }
        );
        const fileViewState = prepareSharePointFileViewState(fileInformation);
        if (fileViewState) {
            previewSharePointFileInNewSxS(fileViewState);
        } else {
            const error = new Error(loc(fileshubPreviewNotSupportedError));
            getSxSViewStore().datapoint.endWithError(DatapointStatus.ClientError, error);
        }
    } else {
        logUsage(GroupFilesHubRecentFilesCardDefaultActionClickName, {
            IndexOfCard: cardIndex.toString(),
            ActionPerformed: 'Download',
        });
        downloadRecentFileAction(fileInformation);
    }
}
